<template>
  <div class="sm-diagram-settings">
    <div class="sm-diagram-settings-block">
      <r-text type="caption" style="margin-bottom: 8px;">
        Тип максимума
      </r-text>
      <div class="sm-diagram-settings-block-input">
        <el-select
          class="r-select"
          v-model="maxType"
          placeholder="Выберите тип"
          size="mini"
          :disabled="!!loadingCalc"
        >
          <el-option
            v-for="item in filteredMaxTypes"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>

    <div class="sm-diagram-settings-block" v-if="maxType === 'manual'">
      <r-text type="caption" style="margin-bottom: 8px;">
        Значение максимума
      </r-text>
      <div class="sm-diagram-settings-block-input">
        <el-input-number
          :controls="false"
          class="r-input dark"
          size="mini"
          type="number"
          :max="fieldMax"
          v-model="manualMax"
        />
      </div>
    </div>

    <div class="sm-diagram-settings-block">
      <r-text type="caption" style="margin-bottom: 8px;">
        Максимальная ширина эпюры
      </r-text>
      <div class="sm-diagram-settings-block-inputs">
        <el-slider
          class="r-slider dark square"
          :min="0"
          :max="1000"
          :step="2"
          v-model="diagramWidth"
        />
        <el-input-number
          :controls="false"
          class="r-input dark"
          size="mini"
          type="number"
          :max="1000"
          :min="0"
          v-model="diagramWidth"
        />
      </div>
    </div>

    <div class="sm-diagram-settings-block">
      <r-text type="caption" style="margin-bottom: 8px;">
        Отображение значений на карте
      </r-text>
      <div class="sm-diagram-settings-block-switch">
        <el-switch class="r-switch dark" v-model="showLabels" />
        <r-text type="caption" style="margin-bottom: 8px;">
          {{ showLabels ? "Включено" : "Отключено" }}
        </r-text>
      </div>
    </div>
  </div>
</template>

<script>
const maxTypes = [
  { value: "field", name: "За все время" },
  { value: "manual", name: "Заданный вручную" }
];

const localType = { value: "local", name: "В момент времени" };

export default {
  data() {
    return {
      maxTypes
    };
  },
  computed: {
    filteredMaxTypes() {
      return this.calcMode === "one" ? [localType, ...maxTypes] : maxTypes;
    },
    loadingCalc() {
      return this.$store.state.scenarioModelling.loadingCalc;
    },
    calcMode() {
      return this.$store.state.scenarioModelling.calcMode;
    },
    showLabels: {
      get() {
        return this.$store.state.scenarioModelling.showLabels;
      },
      set(value) {
        this.$store.commit("CHANGE_SM_CALC_PROP", {
          field: "showLabels",
          value
        });
      }
    },
    maxType: {
      get() {
        return this.$store.state.scenarioModelling.maxType;
      },
      set(value) {
        this.$store.commit("CHANGE_SM_CALC_PROP", {
          field: "maxType",
          value
        });
      }
    },
    fieldMax() {
      return this.$store.state.scenarioModelling.fieldMax;
    },
    manualMax: {
      get() {
        return this.$store.state.scenarioModelling.manualMax;
      },
      set(value) {
        this.$store.commit("CHANGE_SM_CALC_PROP", {
          field: "manualMax",
          value
        });
      }
    },
    diagramWidth: {
      get() {
        return this.$store.state.scenarioModelling.diagramWidth;
      },
      set(value) {
        this.$store.commit("CHANGE_SM_CALC_PROP", {
          field: "diagramWidth",
          value
        });
      }
    }
  },
  methods: {
    changeDiagramWidth(value) {
      console.log(value);
      this.$store.commit("CHANGE_SM_CALC_PROP", {
        field: "diagramWidth",
        value
      });
    }
  }
};
</script>

<style lang="scss">
.sm-diagram-settings {
  margin-top: 16px;

  &-block {
    &:not(:first-child) {
      margin-top: 12px;
    }

    &-input {
      .r-input {
        width: 100%;
      }

      .r-select {
        width: 100%;
      }
    }

    &-inputs {
      display: flex;
      align-items: center;

      .r-slider {
        width: 70%;
        margin-right: 10px;
      }

      .r-input {
        width: 30% !important;
        margin-left: 8px;
      }
    }

    &-switch {
      display: flex;

      .r-text.caption-2 {
        margin-left: 8px;
      }
    }
  }
}
</style>
